module.exports = __webpack_public_path__ + "static/media/jeff-siepman-kyuPjZudBKs-unsplash.1b6f9961.jpg";